import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  CreateMessage,
  FindManyMessageThreads,
  MESSAGE_THREAD_TYPE,
} from '@univacity/shared/types';

import { MessagesActions } from './messages.actions';
import * as MessagesSelectors from './messages.selectors';

@Injectable()
export class MessagesFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loading$ = this.store.pipe(select(MessagesSelectors.selectMessagesLoading));
  allEntities$ = this.store.pipe(select(MessagesSelectors.selectAllMessages));
  threads$ = this.store.pipe(select(MessagesSelectors.selectAllMessageThreads));
  selectedEntity$ = this.store.pipe(
    select(MessagesSelectors.selectSelectedMessage)
  );
  selectedThread$ = this.store.pipe(
    select(MessagesSelectors.selectSelectedThread)
  );
  inbox$ = this.store.pipe(select(MessagesSelectors.selectSelectedMessages));
  unread$ = this.store.pipe(select(MessagesSelectors.selectUnread));
  messagePagination$ = this.store.pipe(
    select(MessagesSelectors.messagePagination)
  );

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  fetchThread(query?: FindManyMessageThreads) {
    this.store.dispatch(MessagesActions.fetchThreads({ query }));
  }
  fetchAllUnread() {
    this.store.dispatch(MessagesActions.fetchAllUnreadMessagesCount());
  }
  fetchThreadUnread(thread: string) {
    this.store.dispatch(MessagesActions.fetchUnreadMessagesCount({ thread }));
  }
  fetchMessages(thread: string) {
    this.store.dispatch(MessagesActions.fetchMessages({ thread }));
  }
  sendMessage(thread: string, message: CreateMessage) {
    this.store.dispatch(MessagesActions.sendMessage({ message, thread }));
  }
  select$(thread: string) {
    return this.store.pipe(select(MessagesSelectors.selectEntity(thread)));
  }
  loadMoreMessgae() {
    this.store.dispatch(MessagesActions.loadMoreMessages());
  }
  selectThread(thread?: string) {
    this.store.dispatch(MessagesActions.selectThread({ thread }));
  }
  fetchThreadUnreadByType$(type: MESSAGE_THREAD_TYPE, reference: string) {
    return this.store.pipe(
      select(MessagesSelectors.fetchThreadUnreadByType(type, reference))
    );
  }
}
